import { Handlers } from '../../../types/actions/types';
import CONSTANTS from './constants';

export const initializeCreditBureauCharts = (payload) => {
    return {
        type: CONSTANTS.INITIALIZE_CHARTS_DATA,
        payload,
    };
};

export const fetchChartData = (payload) => {
    return {
        type: CONSTANTS.FETCH_CHART_DATA,
        payload,
    };
};

export const fetchChargeDetails = (payload, handlers: Handlers) => {
    return {
        type: CONSTANTS.FETCH_CHARGE_DETAILS,
        payload,
        handlers,
    };
};

export const fetchCibilOverview = (payload, handlers?) => {
    return {
        type: CONSTANTS.FETCH_CIBIL_OVERVIEW,
        payload,
        handlers,
    };
};

export const fetchDirectorsOverview = (payload) => {
    return {
        type: CONSTANTS.FETCH_DIRECTORS_OVERVIEW,
        payload,
    };
};
export const fetchDirectorBureauCibil = (payload) => {
    return {
        type: CONSTANTS.FETCH_DIRECTOR_BUREAU_CIBIL,
        payload,
    };
};

export const fetchCreditBureauSummaryTable = (payload: CreditBureauSummaryPayload, handlers: Handlers) => {
    return {
        type: CONSTANTS.FETCH_CREDIT_BUREAU_SUMMARY_TABLE,
        payload,
        handlers,
    };
};

export const fetchBureauEnquiryData = (payload: BureauEnquiryPayload, handlers: Handlers) => {
    return {
        type: CONSTANTS.FETCH_BUREAU_ENQUIRY_DATA,
        payload,
        handlers,
    };
};

type CreditBureauSummaryPayload = {
    assesseeOrgId: string;
    directorId?: string;
};

type BureauEnquiryPayload = {
    requestPayload: {
        directorId: string;
        bureauName: string;
    };
};

type BusinessLoansPayload = {
    orgId: string;
    bureauName: string;
};

type EnquiriesPayload = {
    orgId: string;
    bureauName: string;
};

export const fetchBusinessLoansAndRelatedParties = (payload: BusinessLoansPayload, handlers: Handlers) => {
    return {
        type: CONSTANTS.FETCH_BUSINESS_LOANS_AND_RELATED_PARTIES,
        payload,
        handlers,
    };
};

export const fetchEnquiriesAndRelatedParties = (payload: EnquiriesPayload, handlers: Handlers) => {
    return {
        type: CONSTANTS.FETCH_ENQUIRIES_AND_RELATED_PARTIES,
        payload,
        handlers,
    };
};

export const fetchLatestConsents = (payload: { orgId: string }) => {
    return {
        type: CONSTANTS.FETCH_LATEST_CONSENTS,
        payload,
    };
};
